import { supabase } from '@/integrations/supabase/client';

/**
 * Check if a user account is suspended.
 * Returns true if suspended, false otherwise.
 */
export async function checkSuspension(userId: string): Promise<boolean> {
  const { data } = await supabase
    .from('profiles')
    .select('is_suspended')
    .eq('user_id', userId)
    .maybeSingle();

  // is_suspended may not exist in the type but does in the DB
  return !!(data as { is_suspended?: boolean } | null)?.is_suspended;
}
